(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/member-send-email.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/member-send-email.js');
'use strict';

const TextField = svs.arena.pages.teams.components.TextField;
const GridRow = svs.ui.ReactGrid.GridRow;
const handleSendEmailAsync = svs.arena.pages.teams.helpers.handleSendEmailAsync;
const MemberSendEmail = _ref => {
  let onHide = _ref.onHide,
    customerId = _ref.customerId,
    teamId = _ref.teamId,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    _ref$isInactive = _ref.isInactive,
    isInactive = _ref$isInactive === void 0 ? false : _ref$isInactive;
  const currentCustomerId = ReactRedux.useSelector(state => state.teams.customerId);
  const handleSubmit = async message => {
    const memberName = {
      firstName,
      lastName
    };
    const res = await handleSendEmailAsync(teamId, [customerId], message, memberName, currentCustomerId);
    if (!(res !== null && res !== void 0 && res.error)) {
      const track = {
        category: 'spela-tillsammans',
        action: isInactive ? 'action_members_inactive' : 'action_members',
        opt_label: isInactive ? 'send_email_inactive' : 'send_email'
      };
      svs.components.analytics.trackEvent(track);
      onHide();
    }
  };
  const onCancel = () => {
    const track = {
      category: 'spela-tillsammans',
      action: isInactive ? 'action_members_inactive' : 'action_members',
      opt_label: 'cancel_email'
    };
    svs.components.analytics.trackEvent(track);
    onHide();
  };
  return React.createElement(GridRow, {
    gutter: "0"
  }, React.createElement("div", {
    className: "u-block"
  }, React.createElement(TextField, {
    onCancel: onCancel,
    onHide: onHide,
    onSubmit: handleSubmit
  })));
};
svs.arena.pages.teams.teamMembers.MemberSendEmail = MemberSendEmail;

 })(window);